import React from 'react'
import {Card, CardHeader, Col, FormGroup,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import ErrorModal from "../Alerts/ErrorModal";
import reportApiService from "../../api/report-api-service";
import HeaderAlert from "../Alerts/SuccessAlert";
import businessHelper from "../../helpers/BusinessHelper";
import moment from "moment";
import {SingleDatePicker} from "react-dates";
import TsessionTable from "./TsessionTable";
import Label from "reactstrap/es/Label";
import ConfirmationModal from "../Alerts/ConfirmationModal";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const propTypes = {};

export default class Tsessions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            date: new Date(),
            sessions: null,
            alertData: null,
            confirm_delete_session_id: null
        };
    }

    confirmDeleteSession = this.confirmDeleteSession.bind(this);
    toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
    deleteSession = this.deleteSession.bind(this);
    handleNetworkError = this.handleNetworkError.bind(this);

    componentDidMount() {
        localStorage.teacher_session_date = new Date();
        this.getData();
    }

    componentWillUnmount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.date != this.state.date) {
            this.getData()
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    toggleConfirmationModal() {
        this.setState({confirm_delete_session_id: null})
    }

    updateDate(date) {
        const newDate = date.date.format('YYYY-MM-DD')
        localStorage.teacher_session_date = newDate

        this.setState(prevState => ({
            date: newDate
        }));
    }

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.alertData &&
                    <HeaderAlert alertData={this.state.alertData}/>
                    }

                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    {this.state.confirm_delete_session_id &&
                    <ConfirmationModal showModal={this.state.confirm_delete_session_id != null} alertTitle={alertStrings.confirmation_alert_title}
                                       alertBody={""}
                                       confirmationAction={this.deleteSession}
                                       toggleModal={this.toggleConfirmationModal}/>
                    }

                    <Col lg="12">
                        <Card className="bg-default shadow">


                            <Row style={{marginLeft: 4}}>
                                <FormGroup style={{margin: 4}}>
                                    {/*<label*/}
                                    {/*    style={{marginRight: 4}}*/}
                                    {/*    className="form-control-label"*/}
                                    {/*    htmlFor="input-start"*/}
                                    {/*>*/}
                                    {/*    {commonStrings.date}*/}
                                    {/*</label>*/}
                                    <SingleDatePicker
                                        date={moment(this.state.date)} // momentPropTypes.momentObj or null
                                        onDateChange={date => this.updateDate({date})} // PropTypes.func.isRequired
                                        focused={this.state.focused} // PropTypes.bool
                                        onFocusChange={({focused}) => this.setState({focused})} // PropTypes.func.isRequired
                                        isOutsideRange={() => false}
                                        id="date_input" // PropTypes.string.isRequired,
                                    />
                                </FormGroup>

                            </Row>
                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent">
                                    <Row>
                                        <h2 className="text-white mb-0">{commonStrings.teacher_sessions}</h2>

                                        <div style={{position: "absolute", right: 20, top: 10}}>
                                        </div>
                                    </Row>
                                </CardHeader>
                                {this.renderReport()}
                                <label style={{margin: 10}}>
                                    {resourceStrings.teacher_sessions_expl}
                                </label>
                            </Card>
                        </Card>
                    </Col>
                </>
            </LoadingOverlay>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getData() {
        this.setState({isLoading: true, sessions: []});

        reportApiService.getTeacherSessions(businessHelper.business().id, this.state.date)
            .then(res => {
                if (res.sessions) {
                    this.setState({
                        sessions: res.sessions,
                        isLoading: false,
                    });
                } else {
                    this.setState({
                        sessions: [],
                        isLoading: false,
                    });
                }

                this.renderReport()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    renderReport() {
        if (this.state.sessions !== null && this.state.sessions.length > 0) {
            return <TsessionTable
                sessions={this.state.sessions}
                deleteSession={this.confirmDeleteSession}
            />;
        } else return (<Label className="ml-2">
            {reportStrings.no_transactions_for_day}
        </Label>)
    }

    confirmDeleteSession(e, session) {
        e.preventDefault();
        this.setState({confirm_delete_session_id: session.id})
    }

    deleteSession() {
        reportApiService.deleteSession(this.state.confirm_delete_session_id)
            .then(res => {
                this.getData();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

}

Tsessions.propTypes = propTypes;